<template>
  <div
    ref="dropdown"
    v-on-clickaway="onClickAway"
    :class="{'suggest-select': true, 'has-focus': componentHasFocus}"
    @click="handleComponentClick">
    <text-field
      ref="textInput"
      class="text-input"
      :label="label"
      :leading-icon="leadingIcon"
      trailing-icon="arrow_drop_down"
      type="text"
      :valid.sync="valid"
      :value.sync="inputVal"
      filled
      @click="handleComponentClick" />
    <m-text-field-helper-text
      v-if="helper"
      :validation-msg="validationMsg"
      :persistent="persistent">
      {{ helper }}
    </m-text-field-helper-text>
    <m-elevation
      v-if="componentHasFocus"
      transition
      :level="8"
      class="dropdown">
      <ul
        v-if="componentHasFocus"
        class="list-items">
        <m-list-item
          v-for="option in filteredOptions"
          :key="option"
          class="dropdown-option"
          @click.prevent.stop="handlePrimarySelect(option)"
        >
          {{ option }}
        </m-list-item>
      </ul>
    </m-elevation>
  </div>
</template>
<script>
import Elevation from 'material-components-vue/dist/elevation'
import List from 'material-components-vue/dist/list'
import TextField from '../text-field/text-field.vue'
import { directive as onClickaway } from 'vue-clickaway'

import Vue from 'vue'
Vue.use(List)
Vue.use(Elevation)
export default {
  components: {
    TextField
  },
  directives: {
    onClickaway: onClickaway
  },
  props: {
    label: {
      default: '',
      required: false,
      type: String
    },
    handlePrimaryVal: {
      default: () => {},
      required: false,
      type: Function
    },
    helper: {
      default: '',
      required: false,
      type: String
    },
    leadingIcon: {
      default: '',
      required: false,
      type: String
    },
    options: {
      required: true,
      type: Array
    },
    persistent: {
      default: false,
      required: false,
      type: Boolean
    },
    primaryVal: {
      default: '',
      required: false,
      type: String
    },
    valid: {
      default: true,
      required: false,
      type: Boolean
    },
    validationMsg: {
      default: false,
      required: false,
      type: Boolean
    }
  },
  data () {
    return {
      componentHasFocus: false,
      inputVal: this.primaryVal
    }
  },
  computed: {
    filteredOptions () {
      return this.options.filter((option) => {
        if (!this.primaryVal) {
          return true
        } else {
          return option.toLowerCase().includes(this.primaryVal.toLowerCase())
        }
      })
    }
  },
  watch: {
    inputVal () {
      this.handlePrimaryVal(this.inputVal)
    },
    primaryVal () {
      this.inputVal = this.primaryVal
      this.handlePrimaryVal(this.primaryVal)
    }
  },
  methods: {
    clearVals () {
      this.handlePrimaryVal('')
      this.inputVal = ''
      this.$nextTick(() => {
        this.componentHasFocus = true
      })
    },
    handleComponentClick () {
      this.$nextTick(() => {
        this.componentHasFocus = true
      })
    },
    handlePrimarySelect (val) {
      this.handlePrimaryVal(val)
      this.inputVal = val
      this.$nextTick(() => {
        this.componentHasFocus = false
      })
    },
    onClickAway (e) {
      this.componentHasFocus = false
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../universal/vars.scss';
@import '@material/list/mdc-list';
@import 'material-components-vue/dist/elevation/styles';
.suggest-select {
  font-size: 16px;
  position: relative;
}
.dropdown {
  background: #FAFAFA;
  border-radius: 4px;
  top: 54px;
  z-index: 200;
  position: absolute;
  width: 100%;
}
.list-items {
  padding-left: 0;
  margin: 0;
  max-height: 200px;
  overflow: auto;
}
.primary-val {
  margin-bottom: 8px;
}
.primary-val:hover {
  background: transparent;
  background-color: transparent;
}
.mdc-list-item {
  color: $black-high-emphasis;
}
.dropdown-wrap .mdc-text-field-helper-line {
  height: 8px;
}

// input styles
.text-input {
  height: 56px;
  width: 100%;
  border: none;
  border-radius: 4px 4px 0 0;
  outline: none;

  cursor: initial;
  font-size: 16px;
  color: $black-high-emphasis;
  background-color: whitesmoke;
}
/deep/ .has-focus .text-input {
  background-color: $input-background;
}
/deep/ .text-input .mdc-text-field--with-leading-icon.mdc-text-field {
  width: 100%;
}
.text-field-resizable {
  margin: 12px 0;
}
/deep/ .mdc-text-field.mdc-text-field--disabled {
  background-color: whitesmoke;
}
.text-field-resizable[disabled=disabled] .mdc-text-field__input {
  border-bottom: 1px solid rgba(0, 0, 0, 0.42);
}

// hover themes
.mdc-text-field--disabled:hover {
  border-bottom: 1px solid black;
}
/deep/ .text-field-resizable[disabled=disabled]:hover .mdc-text-field__input {
  background: $input-background--hover;
}

// focus themes
/deep/ .text-field-resizable[disabled=disabled]:not(.mdc-text-field--disabled):not(.mdc-text-field--outlined):not(.mdc-text-field--textarea):hover .mdc-text-field__input {
  border-bottom-color: black;
}
.has-focus::v-deep .text-field-resizable[disabled=disabled] .mdc-text-field__input {
  background: $input-background--focused;
}

// invalid themes
.mdc-text-field.mdc-text-field--focused.mdc-text-field--invalid .mdc-notched-outline__leading,
.mdc-text-field.mdc-text-field--focused.mdc-text-field--invalid .mdc-notched-outline__notch,
.mdc-text-field--textarea.mdc-text-field--focused.mdc-text-field--invalid .mdc-notched-outline__trailing {
  border-color: $mdc-theme-error;
  border-width: 1px;
}

// text field helper styles
/deep/ .mdc-text-field-helper-text--persistent {
  margin-left: 12px;
  position: relative;
  top: -13px;
  color: $black-medium-emphasis;
}

// icons
.material-icons {
  color: $black-medium-emphasis;
}
.back-icon {
  margin-right: 16px;
  position: relative;
}
.back-icon::after {
  content: '';
  position: absolute;
  width: 328px;
  height: 1px;
  bottom: -12px;
  left: 0;
  background-color: rgba(0, 0, 0, 0.12);
}
.icon-right {
  position: absolute;
  right: 12px;
}
/deep/ i {
  outline: none;
}
</style>
